import useTranslation from 'next-translate/useTranslation';
import type { FC } from 'react';

import { Translate } from '@core/constant';
import { EActionAttribute, ETypographyVariant, EColor } from '@core/type';

import { Link } from './Link';
import { LinkCustomProps } from './interface-link';

export const LinkResendUnlockInstructions: FC<LinkCustomProps> = ({
  ...props
}: LinkCustomProps): JSX.Element => {
  const { t } = useTranslation(Translate.common.LINK);

  return (
    <Link
      variant={ETypographyVariant.BODY3}
      color={EColor.ACCENT}
      {...props}
      as={EActionAttribute.BUTTON}
    >
      {t('resendUnlockInstructions.title')}
    </Link>
  );
};
